import { Header, Popup, Icon } from 'semantic-ui-react';
import ProductionEstimateButton from '~/components/ProductionEstimateButton';
import { ReactComponent as DNVLogo } from '~/assets/dnv.svg';
import '../styles.scss';

interface ProductionEstimateProps {
  projectDisplayValues: any;
  project?: any;
  projectErrors?: any;
}

export default function ProductionEstimate({
  projectDisplayValues,
  project,
  projectErrors
}: ProductionEstimateProps) {
  const prodEstimate = projectDisplayValues?.productionEstimates;

  const yearOneProduction = projectDisplayValues?.yearOneProduction;
  const estVal = prodEstimate?.estVal;

  return (
    <div className="production-estimate-container">
      <Header as="h2">
        Production estimate
        <Popup
          inverted
          trigger={<Icon name="info circle" size="large" style={{ color: 'var(--color-charcoal' }} tabIndex={0} />}
          content={
            <div>
              <strong style={{ fontSize: '16px' }}>Production Estimate</strong>
              <p style={{ color: '#FFFFFF', margin: '1em 0em' }}>
                The estimated p50 range is computed by DNV&apos;s Solar Resource Compass (SRC) web-service, incorporating user-provided project capacity, location, mounting type and orientation. SRC automatically models inputs including irradiance, snow, soiling and albedo impacts. Click the logo to learn more about DNV.
              </p>
            </div>

          }
          position="top center"
          on={['hover', 'focus']}
        />

      </Header>
      <div className="production-estimate">
        <div className="estimate-item">
          <span className="estimate-value">{estVal} kWh/kW</span>
          <span className="estimate-label">DNV Estimate</span>
        </div>
        <div className="estimate-item">
          <span className="estimate-value">{yearOneProduction} kWh/kW</span>
          <span className="estimate-label">Developer-provided</span>
        </div>
        <ProductionEstimateButton project={project} values={projectDisplayValues} errors={projectErrors} />
        <div className="powered-by">
          <span>Powered by</span> <a href="https://www.dnv.com/power-renewables/generation/solar-energy.html" target="_blank" rel="noreferrer"><DNVLogo /></a>
        </div>
      </div>
    </div>
  );
}

